const mixpanel = globalThis.mixpanel;

export { mixpanel };
